import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { SiteWatertempTrendModel } from 'src/app/models/SiteDetails/SiteWatertempTrendModel';
import { differenceInCalendarDays, sub, add } from 'date-fns';
import { BehaviorSubject } from 'rxjs';
import { uniq } from 'lodash';
import { SimpleDatatable } from 'src/app/models/SimpleDatatable';
import { formatDate } from '@angular/common';
import { googleChartsTooltipHtml, formatTooltipHtml } from '../../shared/google-charts/GoogleChartsTooltipStyles';
import { CHART_DATE_FORMAT, CHART_TOOLTIP_ENTEROCOCCI_UNITS, CHART_TOOLTIP_WATERTEMP_UNITS, FORMAT_DATE_LOCALE } from 'src/app/models/app-constants';
import { convertToAESTDateTime, formatDateAEST } from '../utils';

declare var google : any;


@Component({
	selector: 'app-water-temperature-chart',
	templateUrl: './water-temperature-chart.component.html',
	styleUrls: ['./water-temperature-chart.component.scss']
})
export class WaterTemperatureChartComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
	waterTempTrends$ : BehaviorSubject<SiteWatertempTrendModel[]> = new BehaviorSubject<SiteWatertempTrendModel[]>([]);
	@Input() siteName : string;
	@Input() monthlyChart : boolean = true;

	public chartDataView : any;
	public chartOptions : any;
	public monthlyWaterTempData : any;

	@Input()
	get waterTempTrends() {
		return this.waterTempTrends$.getValue();
	}
	set waterTempTrends(value) {
		this.waterTempTrends$.next(value);
	}

	ngOnInit(): void {
		this.waterTempTrends$.subscribe({
			next : (data) => {
				this.createChart(data);
			}
		})
	}

	ngOnChanges(changes: SimpleChanges): void {
		
	}

	ngAfterViewInit(): void {
		
	}

	ngOnDestroy(): void {
		
	}

	private createChart(trendsData : SiteWatertempTrendModel[]) {
		const sortedArray = trendsData.sort(function compare(a :  SiteWatertempTrendModel, b : SiteWatertempTrendModel) {
			const dateA = new Date(a.MeasurementDt);
			const dateB = new Date(b.MeasurementDt);
			return dateA.getTime() - dateB.getTime();
		});

		const maxDate = new Date();
		const minDate = this.monthlyChart ? sub(maxDate, {days: 30}) : sub(maxDate, {days: 365});

		
		const filteredData = sortedArray.filter((d) => {
			return d.MeasurementDt.getTime() >= minDate.getTime() &&
				d.MeasurementDt.getTime() <= maxDate.getTime();
		});

		
		this.chartDataView = new google.visualization.DataTable();
		this.chartDataView.addColumn('date', 'Measurement Date');
		this.chartDataView.addColumn('number', 'WaterTemp');		
		this.chartDataView.addColumn({'type' : 'string', 'role' : 'tooltip', 'p': {'html': true}});	

		//this.monthlyWaterTempData = [["Measurement date"], ["Water temperature"]];
		
		for(let i = 1; i <=  differenceInCalendarDays(maxDate, minDate); ++i)
		{			
			const day = add(minDate, {days : i });
			const dayData =filteredData.find((a : any) => 0 === differenceInCalendarDays(day, a.MeasurementDt));
			if(dayData)
			{
				const measurementDt = convertToAESTDateTime(dayData.MeasurementDt) ?? dayData.MeasurementDt;
				const dt = new Date(measurementDt.getFullYear(), measurementDt.getMonth(), measurementDt.getDate(),
				measurementDt.getHours(), measurementDt.getMinutes(), measurementDt.getSeconds(), measurementDt.getMilliseconds());

				this.chartDataView.addRow([
					dt,
					dayData.WaterTemp,
					formatTooltipHtml(
						dayData.WaterTemp.toString(),
						CHART_TOOLTIP_WATERTEMP_UNITS,
						formatDateAEST(dt, CHART_DATE_FORMAT, FORMAT_DATE_LOCALE),
					)
				]);				

				//this.monthlyWaterTempData[0].push(formatDateAEST(measurementDt, "dd/MM/yyyy", "en-AU"));
				//this.monthlyWaterTempData[1].push(dayData?.WaterTemp);
			}			
		}				
		

		const uniqueYValues = uniq(filteredData.map((a) => a.WaterTemp));
		const maxYValue = Math.max(...filteredData.map((a) => a.WaterTemp));
		
		this.chartOptions = {
			theme: 'material',
			interpolateNulls : false,
			tooltip : { isHtml : true, trigger : 'focus' },	
			width: '100%', height: '100%',
			explorer: {
				axis: 'horizontal',
				keepInBounds: true
			},
			chartArea: {
			  width: '95%',
			  left: 40
			},
			pointSize : 10,
			pointShape : { type: 'circle' },
			pointsVisible : true,
			lineWidth : 2,			
			hAxis : { 				
				format : "dd/MM//YY",
				gridlines : {
					count : 0
				}			
			},
			vAxis : { 
				minValue : 0, maxValue : maxYValue,				
				//ticks : uniqueYValues.map((a) => ({v : a, f : a.toString() + "°C"})),
				// set viewWindow.max to positive value >= in order to show only the positive y axis
				viewWindow: {min: 0, max : maxYValue >= 0 ? maxYValue : 1},
				minorGridlines : { count : 0 }					
			},
			legend : "none"
		}
	}
}
